export default "__VITE_PUBLIC_ASSET__02612f81__"